import InlineTextInput from '@/components/ui/inline-text-input';
import { pdkAxios } from '@/lib/pdk-axios';
import type { Trade } from '@/models/types';
import { tradesStore } from '@/stores/trades-store';
import { useMutation } from '@tanstack/react-query';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

const TradeVehicleExteriorColorEditor = ({
  tradeId,
  initialExteriorColor,
}: {
  tradeId: Trade['id'];
  initialExteriorColor: string;
}) => {
  const [exteriorColor, setExteriorColor] = useState(initialExteriorColor);

  const updateExteriorColorMutation = useMutation({
    onMutate: async ({ exteriorColor }: { exteriorColor: string }) => {
      tradesStore.updateTrade(tradeId, {
        exterior_color: exteriorColor,
      });
    },
    mutationFn: async ({ exteriorColor }: { exteriorColor: string }) => {
      const response = await pdkAxios.post(
        `/trades/${tradeId}/exterior_color`,
        // /api/trades/:trade_id/exterior_color
        {
          exterior_color: exteriorColor,
        },
      );

      return response.data;
    },
    onSuccess: () => {},
    onError: (error, variables) => {
      console.error('Error updating exterior color', error, variables);
      // TODO: handle error by adding the original cdkId back to the store
    },
  });

  const handleExteriorColorChange = useCallback(
    debounce((newExteriorColor: string) => {
      updateExteriorColorMutation.mutate({ exteriorColor: newExteriorColor });
    }, 1000),
    [],
  );

  useEffect(() => {
    if (exteriorColor === initialExteriorColor) return;

    handleExteriorColorChange(exteriorColor);
  }, [exteriorColor]);

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setExteriorColor(e.target.value);
  }, []);

  useEffect(() => {
    setExteriorColor(initialExteriorColor);
  }, [initialExteriorColor]);

  return (
    <div className="flex flex-row gap-1 items-center justify-between">
      <div className="flex flex-row gap-1 items-center">
        <div className="text-sm text-gray-500 dark:text-white">
          Exterior Color
        </div>
      </div>
      <InlineTextInput
        value={exteriorColor}
        onChange={onChange}
        placeholder="Enter exterior color"
        className="text-right"
        wrapperClassName="gap-1"
      />
    </div>
  );
};

export default TradeVehicleExteriorColorEditor;
